import { useMemo } from 'react';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { WorklistItemStatus } from '../generated/graphql';
import { useCurrentCaseContext } from 'common/CurrentCase/CurrentCaseProvider';
import { WithApolloContext } from 'modules/Apollo/types';

export function useCurrentCaseClaimedStatus({ context }: WithApolloContext): {
  isClaimedBySomeoneElse: boolean;
  isClaimedByMe: boolean;
  isClaimed: boolean;
  isArchived: boolean;
} {
  const { currentCase } = useCurrentCaseContext();
  const { data } = useCurrentUser({ context });
  const me = data?.me;

  const isClaimedBySomeoneElse = useMemo(() => {
    return (
      currentCase != null &&
      me != null &&
      currentCase.claimedBy?.id != null &&
      currentCase.claimedBy?.id !== me.id
    );
  }, [currentCase, me]);

  const isClaimedByMe = useMemo(() => {
    return (
      currentCase != null &&
      me != null &&
      currentCase.claimedBy?.id != null &&
      currentCase.claimedBy?.id === me.id
    );
  }, [currentCase, me]);

  const isClaimed = useMemo(() => {
    return currentCase != null && currentCase.claimedBy?.id != null;
  }, [currentCase]);

  const isArchived = useMemo(() => {
    return currentCase?.status === WorklistItemStatus.Archive;
  }, [currentCase?.status]);

  return useMemo(
    () => ({
      isClaimed,
      isClaimedByMe,
      isClaimedBySomeoneElse,
      isArchived,
    }),
    [isClaimed, isClaimedByMe, isClaimedBySomeoneElse, isArchived]
  );
}
